import buildFormatLongFn from 'date-fns/locale/_lib/buildFormatLongFn';
import buildLocalizeFn from 'date-fns/locale/_lib/buildLocalizeFn';

const eraValues = {
  narrow: ['B', 'คศ'],
  abbreviated: ['BC', 'ค.ศ.'],
  wide: ['ปีก่อนคริสตกาล', 'คริสต์ศักราช'],
};

const monthKeys = [
  'jan_narrow',
  'feb_narrow',
  'mar_narrow',
  'apr_narrow',
  'may_narrow',
  'jun_narrow',
  'jul_narrow',
  'aug_narrow',
  'sep_narrow',
  'oct_narrow',
  'nov_narrow',
  'dec_narrow',
];

var monthValues = {
  narrow: monthKeys,
  abbreviated: monthKeys,
  wide: [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
  ],
};

var dayValues = {
  narrow: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  short: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  abbreviated: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  wide: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
};

const formatLong = {
  date: buildFormatLongFn({
    formats: {
      full: "'วันนี้วันที่' d MMMM yyyy",
      long: 'd MMMM yyyy',
      medium: 'd MMM yyyy',
      short: 'dd/MM/yyyy',
    },
    defaultWidth: 'full',
  }),
  time: buildFormatLongFn({
    formats: {
      full: 'HH:mm:ss น.',
      long: 'HH:mm:ss',
      medium: 'HH:mm',
      short: 'HH:mm',
    },
    defaultWidth: 'medium',
  }),
  dateTime: buildFormatLongFn({
    formats: {
      full: "EEEE, d MMMM yyyy 'เวลา' HH:mm น.",
      long: "d MMMM yyyy 'เวลา' HH:mm",
      medium: 'd MMM yyyy, HH:mm',
      short: 'dd/MM/yyyy, HH:mm',
    },
    defaultWidth: 'full',
  }),
};

const localize = {
  era: buildLocalizeFn({ values: eraValues, defaultWidth: 'wide' }),
  month: buildLocalizeFn({ values: monthValues, defaultWidth: 'wide' }),
  day: buildLocalizeFn({ values: dayValues, defaultWidth: 'wide' }),
};

const myLocale = {
  code: 'key', // กำหนดรหัส locale (เช่น "th" สำหรับภาษาไทย)
  formatLong,
  localize,
};

export default myLocale;
